export default {
  setting: {},
  settinginteraction: {},
  sympla: {
    token: ''
  },
  zoom: {
    zoom_api_key: '',
    zoom_api_secret: ''
  },
  notificationList: [],
  paginationnl: {}
}
